"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorPicker = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactColor = require("react-color");

var _dropdownCore = require("../dropdown-core");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

(0, _loadStyles.default)(".c8846761b{position:relative}.cae5204e2{display:none}.c8ec32015{display:flex;align-items:center}.cdd099620{cursor:pointer;width:1.6rem;height:1.6rem;border-radius:50%;border:1px solid var(--color-flomni-gray-10);box-sizing:border-box}.cdd099620:hover{opacity:.7}.cdfa97a28{margin-left:1.3rem;font-size:1rem;font-weight:400;line-height:1.125rem;color:var(--color-flomni-gray-90)}.c5c5c09b2 .cdd099620{cursor:default}");
var styles = {
  root: 'c8846761b',
  input: 'cae5204e2',
  picker: 'c8ec32015',
  color: 'cdd099620',
  description: 'cdfa97a28',
  '--read-only': 'c5c5c09b2'
};

var ColorPicker = function ColorPicker(props) {
  var color = props.color,
      onChange = props.onChange,
      classes = props.classes,
      dropdownCoreProps = props.dropdownCoreProps,
      readOnly = props.readOnly,
      direction = props.direction;
  var cn = (0, _useStyles.useStyles)(styles, classes);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      displayPicker = _useState2[0],
      setDisplayPicker = _useState2[1];

  var dropdownCorePropsBinded = (0, _react.useMemo)(function () {
    return _objectSpread({
      direction: direction
    }, dropdownCoreProps);
  }, [direction, dropdownCoreProps]);
  var onClickHandler = (0, _react.useCallback)(function () {
    if (readOnly) return;
    setDisplayPicker(!displayPicker);
  }, [displayPicker, readOnly]);
  var onCloseHandler = (0, _react.useCallback)(function () {
    setDisplayPicker(false);
  }, []);
  var onChangeHandler = (0, _react.useCallback)(function (color) {
    onChange(color.hex);
  }, [onChange]);
  var dropdownCore = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react.default.createElement(_dropdownCore.DropdownCore, (0, _extends2.default)({
      active: displayPicker,
      onOverlayClick: onCloseHandler
    }, dropdownCorePropsBinded), /*#__PURE__*/_react.default.createElement(_reactColor.ChromePicker, {
      color: color,
      onChangeComplete: onChangeHandler
    }));
  }, [color, displayPicker, dropdownCorePropsBinded, onChangeHandler, onCloseHandler]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, (0, _defineProperty2.default)({}, cn.read.only, readOnly))
  }, direction !== 'up' ? null : dropdownCore, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.picker
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.color,
    style: {
      background: color
    },
    onClick: onClickHandler
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.description
  }, color.toUpperCase())), direction !== 'down' ? null : dropdownCore);
};

exports.ColorPicker = ColorPicker;
var direction = ['down', 'up'];
ColorPicker.modes = {
  direction: direction
};
ColorPicker.propTypes = {
  /* component logic props */
  color: _propTypes.string.isRequired,
  onChange: _propTypes.func.isRequired,
  dropdownCoreProps: _propTypes.object,
  readOnly: _propTypes.bool,

  /* styling modificators */
  direction: (0, _propTypes.oneOf)(direction),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
ColorPicker.defaultProps = {
  classes: {},
  dropdownCoreProps: {},
  readOnly: false,
  direction: 'down'
};